var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "report-box" }, [
    _c("div", { staticClass: "flex-row box-header" }, [
      _c(
        "div",
        { staticClass: "flex-col flex-10 justify-center" },
        [_vm._t("title")],
        2
      ),
      _c(
        "div",
        { staticClass: "flex-col flex-2 justify-center align-end action" },
        [_vm._t("action")],
        2
      ),
    ]),
    _c("div", { staticClass: "flex-row" }, [
      _c("div", { staticClass: "flex-col flex-1" }, [_vm._t("content")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }